module.exports = "https://d3nn82uaxijpm6.cloudfront.net/packs/media/apps/feed/components/Post/video-icon-9c3e4c55db10a3a613b8f106b675ba9d.png";